import { useState, useMemo, useCallback } from "react";
import { useSnackbar } from 'react-simple-snackbar'
import { utils, Contract } from 'ethers';
import RPM_CARS from "../contracts/RPM_CARS.json";

const curatorAccount = 'NA';//'0x0B869686224088177E2F9C7eCFCC06195760D2dC';

export const useRPMCars = (provider, account, block, config) => {

  const [openSnackbar, closeSnackbar] = useSnackbar();
  const [isBusy, setIsBusy] = useState(false);

  const { carsAddy } = config;

  const contract = useMemo(() => {
    if (!provider) return;
    const _contract = new Contract(
      carsAddy,
      RPM_CARS.abi,
      provider
    );
    return _contract;
  }, [provider]);

  const mint = useCallback(async (_amount, account, balance) => {
    if (!contract || !provider || !_amount) return;
    if (account !== curatorAccount && Number(balance.toString()) < (Number(_amount) * 100).toString() ) {
      openSnackbar('Not enough MATIC');
      return;
    }
    setIsBusy(true)
    try {
      const signer = provider.getSigner(0);
      if (!signer) return;
      let _tx
      if (account === curatorAccount) {
        openSnackbar('Curator Minting RPM Car');
        _tx = await contract.connect(signer).mint(_amount);
        openSnackbar('Curator Minting RPM Car Tx Sent');
      } else {
        openSnackbar('Minting RPM Car');
        _tx = await contract.connect(signer).mint(_amount, { value: utils.parseEther('100') });
        openSnackbar('Minting RPM Car Tx Sent');
      }
      await _tx.wait();
      setIsBusy(false)
      openSnackbar('Minting RPM Car Tx Complete');
    } catch (error) {
      console.error('Minting RPM Car Error: ', error)
      setIsBusy(false)
    }
  }, [contract, provider]);

  return {
    isBusy,
    mint
  };
}
